import cssHasPseudo from "../../node_modules/css-has-pseudo/index.mjs";

import "./imports.js";
import "../superiorenergy.com/modals.js";

cssHasPseudo(document);
